import Vue from 'vue';

import Btn from './Btn.vue';
Vue.component('Btn', Btn);

import ImageSlider from './ImageSlider';
Vue.component('ImageSlider', ImageSlider);

import NavButton from './NavButton.vue';
Vue.component('NavButton', NavButton);

import Popup from './Popup.vue';
Vue.component('Popup', Popup);

import Visualizer from './Visualizer.vue';
Vue.component('Visualizer', Visualizer);

import InputTel from './InputTel.vue';
Vue.component('InputTel', InputTel);
